import styled from "styled-components";

export const UserCardContainer = styled.div`
  direction: ltr;
  position: relative;
  font-size: 10px;

  .swiper {
    width: 240px !important;
  }

  .swiper-slide {
    display: flex;
    align-items: center;

    font-size: 22px;
    color: #fff;
    &.no-color {
      color: #ffc107;
    }
  }

  .custom-font-size {
    font-size: 14px;
    direction: rtl;
  }

  .swiper-button-next::after {
    width: 10px !important;
  }

  img {
  }
  .header {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    > .wallet {
      width: 27px;
      height: 24px;
    }
    > p {
      color: rgb(217, 183, 75);
      text-align: right;
      margin-right: 28px;
      font-size: 21px;
      width: 135px;
    }
  }
  .nasiba-wallet {
    width: 40px;
    position: relative;
    left: 82px;
    bottom: 27px;
  }
  .amount {
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    margin-top: -18px;
  }
  .card {
    width: 259px !important;
  }
  .swiper {
    width: 250px !important;

    overflow: visible;
  }

  .swiper-slide {
    cursor: pointer;
    display: flex;
    align-items: center;
    /* justify-content: center; */

    border-radius: 18px;
    font-size: 22px;
    color: #fff;
  }

  .swiper-pagination-bullets {
    transform: translate(-50%, 24px) !important;
    transition: none !important;
    overflow: visible !important;
  }

  .custom-font-size {
    font-size: 14px;
    direction: rtl;
  }

  .swiper-button-next::after {
    width: 10px !important;
  }

  .navigations {
    font-size: 18px;
    position: absolute;
    top: 65px;
    z-index: 1;
    padding: 0 8px;
    font-weight: bold;
    cursor: pointer;
    color: white;
    &.next {
      right: 0;
    }
    @media (max-width: 1024px) {
      font-size: 7px;
    }

    @media (max-width: 576px) {
      font-size: 5px;
    }
    @media (max-width: 375px) {
      font-size: 4px;
    }
  }
`;
